import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SideBar from "../components/sidebar";
import Header from "../components/header";
import "../assets/CSS/dashboard.css";

function Dashboard({ userData }) {
  return (
    <div>
      <SideBar />
      <div className="main-content">
        <Header />
      </div>
    </div>
  );
}

export default Dashboard;
